import React, { useEffect, useState } from 'react';
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    CircularProgress
} from '@material-ui/core';
import { StyledTableCellProps as StyledTableCell } from '../../commons/utils/TableStyles';
import { FormattedMessage } from 'react-intl';
import * as Utils from '../../commons/utils/Utils';
import { useIntl } from 'react-intl';
import swal from 'sweetalert'
import Security from '../../commons/security/Security.js';

const PresupuestoAsignacion = ({ presupuesto, relacion, onAsignacionChange }) => {

    const intl = useIntl()
    const [asignaciones, setAsignaciones] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editRow, setEditRow] = useState(null); // Track the row being edited
    const [tempValues, setTempValues] = useState({}); // Temporary values for editing
    const [inicioPeriodo, setInicioPeriodo] = useState(false);


    const handleEditRow = (id) => {
        setEditRow(id);
        const asignacion = asignaciones.find((a) => a.id === id);
        if (asignacion) {
            setTempValues((prev) => ({ ...prev, [id]: { ...asignacion } }));
        }
    };

    const validateMontos = () => {
        const totalMontos = {
            monto_general: 0,
            monto_preventivo: 0,
            monto_correctivo: 0,
            monto_gestoria: 0,
            monto_vencimientos: 0,
        };

        asignaciones.forEach((asignacion) => {
            const tempAsignacion = tempValues[asignacion.id] || asignacion; // Usar asignacion como respaldo si tempValues no está definido
            totalMontos.monto_general += parseFloat(tempAsignacion.monto_general) || 0;
            totalMontos.monto_preventivo += parseFloat(tempAsignacion.monto_preventivo) || 0;
            totalMontos.monto_correctivo += parseFloat(tempAsignacion.monto_correctivo) || 0;
            totalMontos.monto_gestoria += parseFloat(tempAsignacion.monto_gestoria) || 0;
            totalMontos.monto_vencimientos += parseFloat(tempAsignacion.monto_vencimientos) || 0;
        });

        return (
            totalMontos.monto_general <= parseFloat(presupuesto.monto_general) &&
            totalMontos.monto_preventivo <= parseFloat(presupuesto.monto_preventivo) &&
            totalMontos.monto_correctivo <= parseFloat(presupuesto.monto_correctivo) &&
            totalMontos.monto_gestoria <= parseFloat(presupuesto.monto_gestoria) &&
            totalMontos.monto_vencimientos <= parseFloat(presupuesto.monto_vencimientos)
        );
    };

    const sendPresupuestoRow = (id) => {
        if (!validateMontos()) {
            swal(
                intl.formatMessage({ id: "PresupuestoAsignacion.alert.monto_superado.title", defaultMessage: "Monto superado" }),
                intl.formatMessage({ id: "PresupuestoAsignacion.alert.monto_superado.message", defaultMessage: "El valor ingresado excede el presupuesto disponible" }),
                "warning"
            );
            return;
        }

        const updatedAsignacion = tempValues[id];
        const updatedAsignaciones = updatedAsignacion
            ? asignaciones.map((a) => (a.id === id ? { ...updatedAsignacion } : a))
            : asignaciones;

        setAsignaciones(updatedAsignaciones);
        setEditRow(null);
        setTempValues((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
        });

        const newDistribuido = updatedAsignaciones.reduce((sum, a) =>
            sum + (parseFloat(a.monto_general) || 0)
                + (parseFloat(a.monto_preventivo) || 0)
                + (parseFloat(a.monto_correctivo) || 0)
                + (parseFloat(a.monto_gestoria) || 0)
                + (parseFloat(a.monto_vencimientos) || 0)
        , 0);

        Utils.sendData('/presupuestos/guardar-asignaciones', 'POST', {
            body: {
                id: id,
                monto_general: getTempValue(id, 'monto_general', 0),
                monto_preventivo: getTempValue(id, 'monto_preventivo', 0),
                monto_correctivo: getTempValue(id, 'monto_correctivo', 0),
                monto_gestoria: getTempValue(id, 'monto_gestoria', 0),
                monto_vencimientos: getTempValue(id, 'monto_vencimientos', 0),
                periodo_id: presupuesto.periodo.id,
                presupuestable_type: relacion.presupuestable,
                presupuestable_id: relacion.id
            },
        })
        .then(() => {
            if (onAsignacionChange) onAsignacionChange(presupuesto.id, newDistribuido);
        })
        .catch((error) => {
            console.error('Error al enviar los datos:', error);
        });
    };

    const cancelEditRow = (id) => {
        setEditRow(null);
        setTempValues((prev) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
        });
    };

    const handleInputChange = (id, field, value) => {
        setTempValues((prev) => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: parseFloat(value) || 0,
            },
        }));
    };

    const getTempValue = (id, field, defaultValue = 0) => {
        return (tempValues[id] && tempValues[id][field] !== undefined) ? parseFloat(tempValues[id][field]) || defaultValue : defaultValue;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [hijosData, inicioPeriodoData] = await Promise.all([
                    Utils.getData(`/presupuestos/subregiones-bases/${relacion.id}?periodoId=${presupuesto.periodo.id}&presupuestableType=${relacion.presupuestable}`),
                    Utils.getData(`/presupuestos/config-periodo-iniciada`),
                ]);
                setAsignaciones(hijosData);
                setInicioPeriodo(inicioPeriodoData);
            } catch (error) {
                console.error('Error al obtener datos de asignación:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f9f9f9', width: '100%' ,overflowX: 'auto' }}>
            <div style={{ padding: '10px', backgroundColor: '#ffffff', border: '1px solid rgb(0, 191, 188)', borderRadius: '5px', width: '95%',
            marginTop: '10px',overflow: 'scroll',maxHeight: '300px'}}>
                <TableContainer>
                    <Table aria-label="clases table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>
                                    {relacion.modulo === 'regiones' ? ( 
                                    <FormattedMessage id="PresupuestoAsignacion.rennder.column_asignacion.SubRegiones" defaultMessage="SUBREGIONES" />
                                    ) : (
                                    <FormattedMessage id="PresupuestoAsignacion.rennder.column_asignacion.Vehiculos" defaultMessage="BASES" />
                                    )}
                                </StyledTableCell>
                                {presupuesto.monto_general > 0 && (
                                <StyledTableCell align="left">
                                    <FormattedMessage id="presupuestoGrid.presupuesto_table.column_general.label" defaultMessage="GENERAL" />
                                </StyledTableCell> 
                                )}
                                {presupuesto.monto_preventivo > 0 && (
                                <StyledTableCell align="left">
                                    <FormattedMessage id="presupuestoGrid.presupuesto_table.column_preventivo.label" defaultMessage="PREVENTIVO" />
                                </StyledTableCell>
                                )}
                                {presupuesto.monto_correctivo > 0 && (
                                <StyledTableCell align="left">
                                    <FormattedMessage id="presupuestoGrid.presupuesto_table.column_correctivo.label" defaultMessage="CORRECTIVO" />
                                </StyledTableCell>
                                )}
                                {presupuesto.monto_gestoria > 0 && (
                                <StyledTableCell align="left">
                                    <FormattedMessage id="presupuestoGrid.presupuesto.column_gestoria.label" defaultMessage="GESTORIA" />
                                </StyledTableCell>
                                )}
                                {presupuesto.monto_vencimientos > 0 && (
                                <StyledTableCell align="left">
                                    <FormattedMessage id="presupuestoGrid.presupuesto.column_vencimientos.label" defaultMessage="VENCIMIENTO" />
                                </StyledTableCell>
                                )}
                                {!inicioPeriodo || Security.hasPermission('PRESUPUESTO_EDITAR_MONTOS_PERIODO') ? (
                                <StyledTableCell>
                                </StyledTableCell> ) : null}
                            </TableRow>
                        </TableHead>                  
                        <TableBody>
                            {loading ? (
                                <TableRow>
                                    <StyledTableCell colSpan={2} align="center">
                                        <CircularProgress />
                                    </StyledTableCell>
                                </TableRow>
                            ) : (
                                    asignaciones.map((asignacion) => (
                                        <TableRow key={asignacion.id}>
                                            <StyledTableCell>{asignacion.nombre}</StyledTableCell>
                                            {presupuesto.monto_general > 0 && (
                                            <StyledTableCell>
                                                {editRow === asignacion.id ? (
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={getTempValue(asignacion.id, 'monto_general') === 0 ? "" : getTempValue(asignacion.id, 'monto_general')}
                                                        onChange={(e) => handleInputChange(asignacion.id, 'monto_general', e.target.value)}
                                                        placeholder='0'
                                                
                                                    />
                                                ) : (
                                                    parseFloat(asignacion.monto_general)
                                                )}
                                            </StyledTableCell>
                                            )}
                                            {presupuesto.monto_preventivo > 0 && (
                                            <StyledTableCell>
                                                {editRow === asignacion.id ? (
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={getTempValue(asignacion.id, 'monto_preventivo') === 0 ? "" : getTempValue(asignacion.id, 'monto_preventivo')}
                                                        onChange={(e) => handleInputChange(asignacion.id, 'monto_preventivo', e.target.value)}
                                                        placeholder='0'
                                                
                                                    />
                                                ) : (
                                                    parseFloat(asignacion.monto_preventivo)
                                                )}
                                            </StyledTableCell>
                                            )}
                                            {presupuesto.monto_correctivo > 0 && (
                                            <StyledTableCell>
                                                {editRow === asignacion.id ? (
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={getTempValue(asignacion.id, 'monto_correctivo') === 0 ? "" : getTempValue(asignacion.id, 'monto_correctivo')}
                                                        placeholder='0'
                                                        onChange={(e) => handleInputChange(asignacion.id, 'monto_correctivo', e.target.value)}
                                                
                                                    />
                                                ) : (
                                                    parseFloat(asignacion.monto_correctivo)
                                                )}
                                            </StyledTableCell>
                                            )}
                                            {presupuesto.monto_gestoria > 0 && (
                                            <StyledTableCell>
                                                {editRow === asignacion.id ? (
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={getTempValue(asignacion.id, 'monto_gestoria') === 0 ? "" : getTempValue(asignacion.id, 'monto_gestoria')}
                                                        placeholder='0'
                                                        onChange={(e) => handleInputChange(asignacion.id, 'monto_gestoria', e.target.value)}
                                                
                                                    />
                                                ) : (
                                                    parseFloat(asignacion.monto_gestoria)
                                                )}
                                            </StyledTableCell>
                                            )}
                                            {presupuesto.monto_vencimientos > 0 && (
                                            <StyledTableCell>
                                                {editRow === asignacion.id ? (
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={getTempValue(asignacion.id, 'monto_vencimientos') === 0 ? "" : getTempValue(asignacion.id, 'monto_vencimientos')}
                                                        placeholder='0'
                                                        onChange={(e) => handleInputChange(asignacion.id, 'monto_vencimientos', e.target.value)}
                                                
                                                    />
                                                ) : (
                                                    parseFloat(asignacion.monto_vencimientos)
                                                )}
                                            </StyledTableCell>
                                            )}
                                            {!inicioPeriodo || Security.hasPermission('PRESUPUESTO_EDITAR_MONTOS_PERIODO') ? (
                                            <StyledTableCell align="center">
                                                {editRow === asignacion.id ? (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-icon btn-dt-grid text-success"
                                                            onClick={() => sendPresupuestoRow(asignacion.id)}
                                              
                                                        >
                                                            <i className="fa fa-check fa-xs" />
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-icon btn-dt-grid text-danger"
                                                            onClick={() => cancelEditRow(asignacion.id)}
                                                   
                                                        >
                                                            <i className="fa fa-times fa-xs" />
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-icon btn-dt-grid text-success"
                                                        onClick={() => handleEditRow(asignacion.id)}
                                                 
                                                    >
                                                        <i className="fa fa-pencil fa-xs" />
                                                    </button>
                                                )}
                                            </StyledTableCell>) : null}
                                        </TableRow>
                                    ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
};

export default PresupuestoAsignacion;